module.exports = __webpack_public_path__ + "static/img/pf2.b95b0e3f.png";